import Quill from 'quill'


const BlockEmbed = Quill.import('blots/block/embed')
const Block = Quill.import('blots/block')

class SoundcloudBlot extends BlockEmbed {
  static create(value) {
    let node = super.create();
     node.setAttribute('width', '100%')
     node.setAttribute('height', value.height)
     node.setAttribute('src', value.src)
     node.setAttribute('frameborder','no')
     node.setAttribute('allow', 'autoplay')
     node.setAttribute('scrolling', 'no')
    return node;
  }

  static value(node) {
    return {
      width: node.getAttribute('width'),
      height: node.getAttribute('height'),
      frameborder: node.getAttribute('frameborder'),
      allow: node.getAttribute('allow'),
      src: node.getAttribute('src'),
      scrolling: node.getAttribute('scrolling')
    };
  }
}



SoundcloudBlot.blotName = 'soundcloud';
SoundcloudBlot.tagName = 'iframe';

class PdfDownloadBlot extends Block {
  static create(value) {
    let node = super.create();
    node.setAttribute('href', value);
    // Okay to set other non-format related attributes
    // These are invisible to Parchment so must be static
    node.setAttribute('target', '_blank');
    return node;
  }

  static formats(node) {
    // We will only be called with a node already
    // determined to be a Link blot, so we do
    // not need to check ourselves
    return node.getAttribute('href');
  }
}

PdfDownloadBlot.blotName = 'pdf-download'
PdfDownloadBlot.tagName = 'a'
PdfDownloadBlot.className = 'pdf-link'



var icons = Quill.import('ui/icons');
icons['embed-soundcloud'] = '<div class="soundcloud-icon"></div>'
icons['pdf-download'] = '<div class="qx-pdf-icon"></div>'


Quill.register(SoundcloudBlot)
Quill.register(PdfDownloadBlot)
export default Quill